import { useEffect, useState } from "react";
import { membershipService } from "../../../services/membershipService";
import { useParams } from "react-router-dom";
import { notify } from '../../../assets/helpers/toast';


export const RCVPrintablePage = () => {

    const params = useParams();
    const { membershipId } = params;
    const [rcv, setRCV] = useState('');


    const getPrintableMembership = (membershipId) => {


        membershipService
            .getPrintableMembership(membershipId)
            .then((response) => {
                if (response.status === 200) {
                    setRCV(response.data?.documents?.rcv || '');
                } else {
                    notify(`${response.message}` || 'error', 'error');
                }

            })
            .catch((error) => { });
        return true;
    };


    useEffect(() => {
        getPrintableMembership(membershipId)
    }, []);
    return (
        <div className="rcv-printable-page" style={{ width: "100%" }}>
            <iframe
                src={rcv}
                width="100%"
                style={{ border: 'none', minHeight: "1200px", height: "100vh" }}
                title="PDF Viewer"
            />
        </div>
    );
}